import { CustomResponseOptionGroupToggle as CommonCustomResponseOptionGroupToggle } from '@aon/tws-common-ui-questions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentConstants from '../../../contentConstants';
import { IExternalAttributeVm, QuestionType } from '../../../models';
import { IApplicationState } from '../../../store';
import { ActionCreators } from '../../../store/CustomQuestionStore';

interface ICustomResponseOptionGroupToggleProps {
	isDemographic?: boolean;
	parentQuestionId?: number;
}

export function CustomResponseOptionGroupToggle(props: ICustomResponseOptionGroupToggleProps) {
	const { customQuestion, clientParticipantAttributes } = useSelector((storeState: IApplicationState) => storeState);
	const dispatch = useDispatch();

	function GetSelectedAttribute() {
		if (customQuestion.externalAttributeColumnName) {
			return clientParticipantAttributes.participantAttributes.find(
				(attr: IExternalAttributeVm) => attr.columnName === customQuestion.externalAttributeColumnName,
			);
		}
		return undefined;
	}
	function GetCheckedValue() {
		if (props.parentQuestionId && props.parentQuestionId > -1) {
			return customQuestion.questionType === QuestionType.Checkbox;
		}
		return customQuestion.isMultiple;
	}
	const attribute = GetSelectedAttribute();
	const enabled = (attribute?.isMultiValue && props.isDemographic) || !props.isDemographic;
	return (
		<CommonCustomResponseOptionGroupToggle
			disabled={!enabled || customQuestion.questionType === QuestionType.Ranking}
			checked={GetCheckedValue()}
			label={ContentConstants.RESPONSE_OPTION_GROUP_TOGGLE_LABEL}
			labelInfo={ContentConstants.RESPONSE_OPTION_GROUP_TOGGLE_TOOLTIP}
			onToggled={(checked: boolean) => {
				dispatch(ActionCreators.ToggleCustomResponseOptionGroupMultiple(checked));
			}}
		></CommonCustomResponseOptionGroupToggle>
	);
}
